import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import { DriverAdminTabs } from '../../components/admin/DriverAdminTabs';
import { ArrowLeft, Car, Loader2, CheckCircle2, AlertCircle, Hash, Palette, Tag } from 'lucide-react';
interface VehicleForm {
  plate: string;
  vehicle_type: string;
  brand: string;
  model: string;
  color: string;
  is_active: boolean;
}
export function CreateVehiclePage() {
  const navigate = useNavigate();
  const [form, setForm] = useState<VehicleForm>({
    plate: '',
    vehicle_type: 'moto',
    brand: '',
    model: '',
    color: '',
    is_active: true
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const updateField = (field: keyof VehicleForm, value: string | boolean) => {
    setForm(prev => ({
      ...prev,
      [field]: value
    }));
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSuccess(false);
    if (!form.plate.trim()) return setError('La placa es obligatoria.');
    setIsSubmitting(true);
    try {
      const {
        error: insertError
      } = await supabase.from('vehicles').insert({
        plate: form.plate.trim().toUpperCase(),
        vehicle_type: form.vehicle_type,
        brand: form.brand.trim() || null,
        model: form.model.trim() || null,
        color: form.color.trim() || null,
        is_active: form.is_active
      });
      if (insertError) throw insertError;
      setSuccess(true);
    } catch (err: any) {
      console.error('[CreateVehicle] Error:', err);
      setError(err.message || 'Error al registrar el vehículo.');
    } finally {
      setIsSubmitting(false);
    }
  };
  if (success) {
    return <div className="min-h-screen bg-[#0B0B0B] text-white font-sans flex flex-col items-center justify-center p-6" data-id="element-3552" data-mp="39lnnxn9ok5lk">
        <div className="max-w-md w-full space-y-6 text-center" data-id="element-3553" data-mp="35ihl6pls0wju">
          <div className="w-20 h-20 bg-[#006847]/20 rounded-full flex items-center justify-center mx-auto" data-id="element-3554" data-mp="12x55iawgzui7">
            <CheckCircle2 className="w-10 h-10 text-[#00a870]" data-id="element-3555" data-mp="17q7yohxc51xv" />
          </div>
          <h1 className="text-2xl font-bold" data-id="element-3556" data-mp="ty9wkr21k6b7">¡Vehículo registrado!</h1>
          <p className="text-white/50" data-id="element-3557" data-mp="xykd2xngmf4b">
            El vehículo {form.plate.toUpperCase()} fue guardado exitosamente.
          </p>

          <div className="flex gap-3 pt-4" data-id="element-3558" data-mp="1lpptpf185bfo">
            <button onClick={() => {
            setSuccess(false);
            setForm({
              plate: '',
              vehicle_type: 'moto',
              brand: '',
              model: '',
              color: '',
              is_active: true
            });
          }} className="flex-1 py-3 bg-white/5 border border-white/10 rounded-xl font-bold text-white/70 hover:bg-white/10 transition-colors" data-id="element-3559" data-mp="1lmlk224zpnhm">
              Registrar otro
            </button>
            <button onClick={() => navigate('/admin/vehicles')} className="flex-1 py-3 bg-[#006847] rounded-xl font-bold text-white hover:bg-[#005a3d] transition-colors" data-id="element-3560" data-mp="3tv043ucagz6m">
              Ver vehículos
            </button>
          </div>
        </div>
      </div>;
  }
  return <div className="min-h-screen bg-[#0B0B0B] text-white font-sans" data-id="element-3561" data-mp="2q9sxainet6t">
      <div className="max-w-lg mx-auto px-4 sm:px-6 py-8 space-y-6" data-id="element-3562" data-mp="3b4s6tsv9t2yc">
        <DriverAdminTabs data-id="element-3563" data-mp="366gxdj8w0ugn" />

        {/* Header */}
        <div className="flex items-center gap-4" data-id="element-3564" data-mp="367rw34nh7c0w">
          <button onClick={() => navigate('/admin/vehicles')} className="w-10 h-10 bg-[#141414] border border-white/10 rounded-xl flex items-center justify-center hover:bg-white/5 transition-colors" data-id="element-3565" data-mp="3kvd3hardvxem">
            <ArrowLeft className="w-5 h-5" data-id="element-3566" data-mp="2se0q268yea9x" />
          </button>
          <div data-id="element-3567" data-mp="2ng8wz8wkoi45">
            <h1 className="text-2xl font-bold" data-id="element-3568" data-mp="2ngh7iu583bc6">Nuevo Vehículo</h1>
            <p className="text-white/40 text-sm" data-id="element-3569" data-mp="2ne4tgs2l5l4e">
              Registra un vehículo en la plataforma
            </p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5" data-id="element-3570" data-mp="1voqgy5n9xx5m">
          {/* Plate */}
          <div data-id="element-3571" data-mp="1zp0lddvf4fid">
            <label className="block text-xs font-bold text-white/40 uppercase tracking-widest mb-2" data-id="element-3572" data-mp="1zo7k2sf8ai7m">
              Placa (Requerido)
            </label>
            <div className="relative" data-id="element-3573" data-mp="29f2b0a3f65ze">
              <Hash className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-white/20" data-id="element-3574" data-mp="29e0n351b1p09" />
              <input type="text" value={form.plate} onChange={e => updateField('plate', e.target.value)} placeholder="ABC-123" className="w-full bg-[#141414] border border-white/10 rounded-xl pl-12 pr-4 py-4 text-base text-white font-mono uppercase placeholder:text-white/15 focus:outline-none focus:border-[#006847] focus:ring-1 focus:ring-[#006847]" required data-id="element-3575" data-mp="2ed3s4phabv88" />
            </div>
          </div>

          {/* Vehicle Type */}
          <div data-id="element-3576" data-mp="ljdxszy168n2">
            <label className="block text-xs font-bold text-white/40 uppercase tracking-widest mb-2" data-id="element-3577" data-mp="lj5hsz6m2n7n">
              Tipo de Vehículo
            </label>
            <select value={form.vehicle_type} onChange={e => updateField('vehicle_type', e.target.value)} className="w-full bg-[#141414] border border-white/10 rounded-xl px-4 py-4 text-base text-white focus:outline-none focus:border-[#006847] focus:ring-1 focus:ring-[#006847] appearance-none" data-id="element-3578" data-mp="bsawpy53ptns">
              <option value="moto" data-id="element-3579" data-mp="vfgxlz5etv6u">🏍️ Moto</option>
              <option value="carro" data-id="element-3580" data-mp="vdxhq9no1m5l">🚗 Carro</option>
              <option value="bicicleta" data-id="element-3581" data-mp="qgnun0nr1mkx">🚲 Bicicleta</option>
              <option value="otro" data-id="element-3582" data-mp="qg4ffrphhcal">📦 Otro</option>
            </select>
          </div>

          {/* Brand & Model */}
          <div className="grid grid-cols-2 gap-4" data-id="element-3583" data-mp="3g3d66xzewys2">
            <div data-id="element-3584" data-mp="3b5lgmam8por1">
              <label className="block text-xs font-bold text-white/40 uppercase tracking-widest mb-2" data-id="element-3585" data-mp="3b51xiqkusubf">
                Marca
              </label>
              <div className="relative" data-id="element-3586" data-mp="3hmmuzbjqyoix">
                <Tag className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-white/20" data-id="element-3587" data-mp="3hmd3tkmyubbn" />
                <input type="text" value={form.brand} onChange={e => updateField('brand', e.target.value)} placeholder="Honda" className="w-full bg-[#141414] border border-white/10 rounded-xl pl-10 pr-4 py-4 text-base text-white placeholder:text-white/15 focus:outline-none focus:border-[#006847] focus:ring-1 focus:ring-[#006847]" data-id="element-3588" data-mp="33mc62e1zzk0e" />
              </div>
            </div>
            <div data-id="element-3589" data-mp="2oxfuw84n9qvk">
              <label className="block text-xs font-bold text-white/40 uppercase tracking-widest mb-2" data-id="element-3590" data-mp="2oyzby0y4k5ye">
                Modelo
              </label>
              <input type="text" value={form.model} onChange={e => updateField('model', e.target.value)} placeholder="Civic" className="w-full bg-[#141414] border border-white/10 rounded-xl px-4 py-4 text-base text-white placeholder:text-white/15 focus:outline-none focus:border-[#006847] focus:ring-1 focus:ring-[#006847]" data-id="element-3591" data-mp="2fxjd8qgo9sa0" />
            </div>
          </div>

          {/* Color */}
          <div data-id="element-3592" data-mp="21cx79ims7qd3">
            <label className="block text-xs font-bold text-white/40 uppercase tracking-widest mb-2" data-id="element-3593" data-mp="2falpeipgsjeg">
              Color
            </label>
            <div className="relative" data-id="element-3594" data-mp="2aahbn0fxy2rx">
              <Palette className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-white/20" data-id="element-3595" data-mp="2a9eg2f7obc5o" />
              <input type="text" value={form.color} onChange={e => updateField('color', e.target.value)} placeholder="Rojo" className="w-full bg-[#141414] border border-white/10 rounded-xl pl-10 pr-4 py-4 text-base text-white placeholder:text-white/15 focus:outline-none focus:border-[#006847] focus:ring-1 focus:ring-[#006847]" data-id="element-3596" data-mp="2p2hsy9abl1q2" />
            </div>
          </div>

          {/* Active Toggle */}
          <div className="flex items-center justify-between bg-[#141414] border border-white/10 rounded-xl p-4" data-id="element-3597" data-mp="9a96c80wjwr1">
            <span className="text-sm font-medium text-white/70" data-id="element-3598" data-mp="d7x5jn9moboq">
              Vehículo activo
            </span>
            <button type="button" onClick={() => updateField('is_active', !form.is_active)} className={`w-14 h-8 rounded-full transition-colors relative ${form.is_active ? 'bg-[#006847]' : 'bg-white/10'}`} data-id="element-3599" data-mp="3ho7z70skv20b">
              <div className={`w-6 h-6 bg-white rounded-full absolute top-1 transition-transform ${form.is_active ? 'translate-x-7' : 'translate-x-1'}`} data-id="element-3600" data-mp="3qnbkmbf7vthz" />
            </button>
          </div>

          {/* Error */}
          {error && <div className="p-4 bg-red-500/10 border border-red-500/20 rounded-xl flex items-start gap-3 text-red-400" data-id="element-3601" data-mp="32y0h4m6hfl05">
              <AlertCircle className="w-5 h-5 shrink-0 mt-0.5" data-id="element-3602" data-mp="2vf0zom2l03jf" />
              <div className="text-sm whitespace-pre-line" data-id="element-3603" data-mp="2qg6hnmcfuj0d">{error}</div>
            </div>}

          {/* Submit */}
          <button type="submit" disabled={isSubmitting} className="w-full py-5 bg-[#006847] hover:bg-[#005a3d] disabled:bg-white/5 disabled:text-white/30 text-white font-black text-lg rounded-xl transition-all flex items-center justify-center gap-2 active:scale-95" data-id="element-3604" data-mp="2lfs5pt7puox2">
            {isSubmitting ? <>
                <Loader2 className="w-6 h-6 animate-spin" data-id="element-3605" data-mp="22qc1auswucbd" />
                Guardando...
              </> : <>
                <Car className="w-6 h-6" data-id="element-3606" data-mp="1xtlp4ik880v8" />
                Registrar Vehículo
              </>}
          </button>
        </form>
      </div>
    </div>;
}